import { memo } from 'react';
import { useProductPricesSub } from '../../hooks/useProductPricesSub';
import { formatNumber } from '../../lib/formatters';
import { Skeleton } from '../Skeleton/Skeleton';

type OraclePriceProps = {
  productId: string;
  priceDecimals: number;
  className?: string;
  skeletonClassName?: string;
};

export const OraclePrice = memo(
  ({ productId, priceDecimals, className, skeletonClassName = 'h-4 w-10' }: OraclePriceProps) => {
    const { data: pricesByProductId } = useProductPricesSub();
    const oraclePrice = pricesByProductId[productId]?.oraclePrice;
    return oraclePrice ? (
      <span className={className}>
        {formatNumber(oraclePrice, {
          minimumFractionDigits: priceDecimals,
          maximumFractionDigits: priceDecimals,
        })}
      </span>
    ) : (
      <Skeleton className={skeletonClassName} />
    );
  }
);
